// extracted by css-extract-rspack-plugin
export default {"treeWrapper":"CharacteristicsActiveStub_treeWrapper__1_74C"};